<template>
    <div class="card card-body">
        <table class="table">
            <thead>
            <tr>
                <th>#</th>
                <th>Art</th>
                <th>Eingang</th>
                <th>Bearbeitet</th>
                <th class="text-right">Aktionen</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="report in userReports">
                <td>{{ report.id }}</td>
                <td>{{ report.type }}</td>
                <td>{{ $localDateTime(report.created_at) }}</td>
                <td>{{ report.resolved_at ? $localDateTime(report.resolved_at) : '-' }}</td>
                <td class="text-right">
                    <Link as="button" :href="$route('user-reports.show', [report.id])" class="btn btn-xs btn-info">
                        <i class="fas fa-eye mr-1" />
                        {{ __('actions.view') }}
                    </Link>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';

export default {
    components: {Link},

    props: {
        userReports: Array
    }
}
</script>
